export default __webpack_public_path__ + "static/media/H'Wear Front Left.090a46f1.jpg";